/* tslint:disable */
/* eslint-disable */
/* @relayHash cbca6c4e320a6260dd57805c4737822c */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type SlackConfigRouteQueryVariables = {};
export type SlackConfigRouteQueryResponse = {
    readonly settings: {
        readonly " $fragmentRefs": FragmentRefs<"SlackConfigContainer_settings">;
    };
};
export type SlackConfigRouteQuery = {
    readonly response: SlackConfigRouteQueryResponse;
    readonly variables: SlackConfigRouteQueryVariables;
};



/*
query SlackConfigRouteQuery {
  settings {
    ...SlackConfigContainer_settings
    id
  }
}

fragment SlackConfigContainer_settings on Settings {
  slack {
    channels {
      siteID
      enabled
      name
      hookURL
      triggers {
        reportedComments
        pendingComments
        featuredComments
        allComments
        staffComments
      }
    }
  }
}
*/

const node: ConcreteRequest = {
    "fragment": {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "SlackConfigRouteQuery",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Settings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SlackConfigContainer_settings"
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Query",
        "abstractKey": null
    },
    "kind": "Request",
    "operation": {
        "argumentDefinitions": [],
        "kind": "Operation",
        "name": "SlackConfigRouteQuery",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "Settings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "SlackConfiguration",
                        "kind": "LinkedField",
                        "name": "slack",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SlackChannel",
                                "kind": "LinkedField",
                                "name": "channels",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "siteID",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "enabled",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "hookURL",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SlackChannelTriggers",
                                        "kind": "LinkedField",
                                        "name": "triggers",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "reportedComments",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "pendingComments",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "featuredComments",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "allComments",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "staffComments",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ]
    },
    "params": {
        "id": "cbca6c4e320a6260dd57805c4737822c",
        "metadata": {},
        "name": "SlackConfigRouteQuery",
        "operationKind": "query",
        "text": null
    }
} as any;
(node as any).hash = 'ae3af33bb97800be86a85968106d6e81';
export default node;
